import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { FC } from 'react';

export interface IWarning {
  door_code: string;
  line_number_error: 2;
  warning: string;
}

/**
 * Предупреждения назначения участников
 */
const ParticipantsXlsxWarnings: FC<{ data: IWarning[] }> = ({ data }) => (
  <TableContainer sx={{ maxHeight: 400 }}>
    <Table
      stickyHeader
      style={{ width: '100%' }}
    >
      <TableHead>
        <TableRow>
          <TableCell
            align="left"
            style={{ width: '10%' }}
          >
            Строка
          </TableCell>
          <TableCell
            align="left"
            style={{ width: '15%' }}
          >
            Код двери
          </TableCell>
          <TableCell align="left">Предупреждение</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row) => (
          <TableRow>
            <TableCell>{row.line_number_error}</TableCell>
            <TableCell>{row.door_code}</TableCell>
            <TableCell>
              {row.warning
                .split(', ')
                .map((word) => {
                  switch (word) {
                    case 'NO_DOOR_CODE':
                      return 'ТТ не найдена';
                    case 'NO_USER_ID':
                      return 'Владелец ТТ не найден';
                    case 'ALREADY_IN_COMPETITION':
                      return 'Уже участвует в соревновании';
                  }
                })
                .join(', ')}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default ParticipantsXlsxWarnings;
